/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Invite_Code_PlaceholderInputs */

const en_common_sign_invite_code_placeholder = /** @type {(inputs: Common_Sign_Invite_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your invite code`)
};

/**
* | output |
* | --- |
* | "Enter your invite code" |
*
* @param {Common_Sign_Invite_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_invite_code_placeholder = /** @type {((inputs?: Common_Sign_Invite_Code_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Invite_Code_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_invite_code_placeholder(inputs)
});
export { common_sign_invite_code_placeholder as "common.sign.invite_code_placeholder" }